import styled, { css } from "styled-components";

export const HomeBannerTwoCont = styled.section`
  & img {
    width: 90%;
    height: auto;
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    & * {
      font-size: 1.1em !important;
    }

    .wrapperImg {
      padding: 0 16px !important;
    }
  }

  ${({ theme: { isMobile ,isRTL} }) =>
    isMobile
      ? css`
          & strong {
            font-size: 29px;
          }

          & a {
            font-size: 20px;
          }

          & button {
            font-size: 20px;
            padding: 18.5px 0;
          }

          & span {
            font-size: 24px;
            line-height: 26px;
          }

          & .wrapperImg {
            padding: 16px;
          }
        `
      : css`
          height: 390.3px;
          > div {
            right: 0;
            left: 0;
          }


          & a {
            padding: 29.35px 0;
            font-size: ${isRTL? "30px" :"26px"};
          }

          & button {
            padding: 22.35px 0;
            font-size: ${isRTL? "30px" :"26px"};
          }

          & .wrapperImg {
            padding: 0 37px;
          }

          [dir="rtl"] & .wrapperImg span {
            font-size: 27px;
            line-height: 28px;
          }

          [dir="ltr"] & .wrapperImg span {
            font-size: 23px;
            line-height: 28px;
          }
        `}
`;

export const HomeBannerTwoMiddle = styled.div`
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    & div {
      padding: 25px 8px !important;
      line-height: 1.2em;
    }
  }
  ${({ theme: { isDesktop } }) =>
    isDesktop
      ? css`
          padding: 0 16px;

          & div {
            font-size: 20px;
            border-radius: 30px;
            padding: 35px 0;
          }

          & span {
            font-size: 43px;
            line-height: 43px;
          }
        `
      : css`
          & strong {
            font-size: 29px;
          }

          & div {
            font-size: 20px;
            border-radius: 30px;
            padding: 35px 20px;
          }
        `}
`;
